<ol class="breadcrumb">
  <li class="breadcrumb-item"><a routerLink="/hospitals">Organizations</a></li>
  <li class="breadcrumb-item">{{hospitalName}}</li>
  <li class="breadcrumb-item">Community Settings</li>
  <li class="breadcrumb-item active">Add a Preferred Transport Company Rule</li>
</ol>
<div class="container">
  <div class="row">
    <div class="col">
      <h1 class="page-heading">Add a Preferred Transport Company Rule</h1>
      <!-- Strategy field -->
      <div class="row g-3 align-items-center p-1">
        <div class="col ms-2">
          <label class="col-form-label">Strategy</label>
        </div>
        <select
          class="form-control"
          [ngClass]="{'error-input': strategy.invalid && (strategy.dirty || strategy.touched || submitted)}"
          [(ngModel)]="ppStrategy"
          [disabled]="!canEditStrategy"
          required
          #strategy="ngModel"
          >
          <option value="" selected="selected">Select a strategy</option>
          @for (strategy of strategyOptions; track strategy) {
            <option [value]="strategy.id">
              {{strategy.name}}
            </option>
          }
        </select>
      </div>
      @if (strategy.invalid && (strategy.dirty || strategy.touched || submitted)) {
        <div>
          @if (strategy.errors.required) {
            <p class="error-msg">
              This field is required.
            </p>
          }
        </div>
      }

      <bs-sortable
        [(ngModel)]="data"
        itemClass="sortable-item"
        itemActiveClass="sortable-item-active"
        placeholderItem="No rules defined yet"
        placeholderClass="placeholderStyle"
        wrapperClass="sortable-wrapper"
        [itemTemplate]="ruleTemplate"
      ></bs-sortable>

      <ng-template #ruleTemplate let-rule="item.value" let-i="index">
        <div class="collapse-bar clearfix p-1" (click)="rule.collapsed = !rule.collapsed">
          <h5 class="pull-left">
            <span class="drag-icon fa fa-bars"></span>
            Attribute
          </h5>
          @if (rule.collapsed) {
            <div class="selected-values">
              @if (rule.model_attribute) {
                <span>
                  {{ modelAttributesMap[rule.model_attribute] }}
                </span>
              }
              @if (rule.model_attribute && rule.value) {
                <span class="fa fa-chevron-right"></span>
              }
              @if (rule.model_attribute && rule.value) {
                <span>
                  {{ allowedValuesMap[rule.model_attribute][rule.value] }}
                </span>
              }
            </div>
          }
          <span></span>
          @if (rule.collapsed) {
            <app-icon icon="chevron-down" iconClass="pull-right"></app-icon>
          }
          @if (!rule.collapsed) {
            <app-icon icon="chevron-up" iconClass="pull-right"></app-icon>
          }
          <button
            class="btn btn-danger pull-right"
            (click)="removeAttributeFromList($event, i)"
            >
            Delete
          </button>
        </div>

        <div class="collapse-block" [collapse]="rule.collapsed">
          <div class="row g-1 align-items-center p-2">
            <div class="col-sm-4 ms-2">
              <label>Attribute</label>
            </div>
            <!-- Note: Add class 'error-input' in case field is invalid -->
            <!-- Note: For an error message add a paragraph element with class 'error-msg' below the field -->
            <div class="col">
              <select
                class="form-control"
                [ngClass]="{'error-input': modelAttribute.invalid && (modelAttribute.dirty || modelAttribute.touched || submitted)}"
                [(ngModel)]="rule.model_attribute"
                required
                #modelAttribute="ngModel"
                >
                <option value="" selected="selected">Select an attribute</option>
                @for (attributeType of modelAttributeOptions; track attributeType) {
                  <option [value]="attributeType.id">
                    {{attributeType.name}}
                  </option>
                }
              </select>
            </div>
            @if (modelAttribute.invalid && (modelAttribute.dirty || modelAttribute.touched || submitted)) {
              <div>
                @if (modelAttribute.errors.required) {
                  <p class="error-msg">
                    This field is required.
                  </p>
                }
              </div>
            }
          </div>
          @if (rule.model_attribute) {
            <div class="col-auto p-1">
              <div class="row g-1 align-items-center p-2">
                <div class="col-sm-4">
                  @if (rule.model_attribute=='vehicle_category') {
                    <label>Vehicle Type</label>
                  }
                  @if (rule.model_attribute=='payer_category') {
                    <label>Payer Type</label>
                  }
                </div>
                <div class="col">
                  <select
                    class="form-control"
                    [ngClass]="{'error-input': (ruleValue.invalid && (ruleValue.dirty || ruleValue.touched || submitted)) || hasUniquenessError(rule.model_attribute, rule.value)}"
                    [(ngModel)]="rule.value"
                    required
                    #ruleValue="ngModel"
                    >
                    @if (rule.model_attribute=='vehicle_category') {
                      <option value="" selected="selected">Select a vehicle type</option>
                    }
                    @if (rule.model_attribute=='payer_category') {
                      <option value="" selected="selected">Select a payer type</option>
                    }
                    @for (attributeValue of valueOptions[rule.model_attribute]; track attributeValue) {
                      <option [value]="attributeValue.id">
                        {{attributeValue.name}}
                      </option>
                    }
                  </select>
                </div>
                @if (ruleValue.invalid && (ruleValue.dirty || ruleValue.touched || submitted)) {
                  <div>
                    @if (ruleValue.errors.required) {
                      <p class="error-msg">
                        This field is required.
                      </p>
                    }
                  </div>
                }
                @if (hasUniquenessError(rule.model_attribute, rule.value)) {
                  <div>
                    <p class="error-msg">
                      This attribute has already been used.
                    </p>
                  </div>
                }
              </div>
            </div>
          }

          <div class="row">
            <div class="row g-0 align-items-center">
              <div class="col ms-4">
                <label>Select Transport Companies</label>
              </div>
              <div class="col-sm-8 ms-4">
                <input
                  type="text"
                  class="form-control"
                  [ngClass]="{'error-input': (data[i].transportation_company_ids.length < 1 || (ppStrategy === 'single' && data[i].transportation_company_ids.length > 1)) && (selectProviders.dirty || selectProviders.touched || submitted)}"
                  [(ngModel)]="data[i].selectedProviderTemp"
                  [typeahead]="data[i].dataSource"
                  typeaheadOptionField="name"
                  (typeaheadOnSelect)="onProviderSelect($event, i)"
                  [disabled]="isSelectProviderDisabled(i)"
                  placeholder="Search by transportation company name"
                  #selectProviders="ngModel"
                  />
              </div>
              @if (selectProviders.dirty || selectProviders.touched || submitted) {
                <div>
                  @if (data[i].transportation_company_ids.length < 1) {
                    <p class="error-msg">
                      Please select at least one transportation company.
                    </p>
                  }
                  @if (ppStrategy === 'single' && data[i].transportation_company_ids.length > 1) {
                    <p class="error-msg">
                      Cannot select more that one transportation companies for single strategy.
                    </p>
                  }
                </div>
              }
              @if (rule.transportation_company_ids.length) {
                <div class="form-inline">
                  <label></label>
                  <ul class="form-control select-list">
                    @for (providerId of rule.transportation_company_ids; track providerId) {
                      <li class="clearfix">
                        <span class="drag-icon fa fa-bars"></span>
                        <span>{{providers[providerId]}}</span>
                        @if (!rule.collapsed) {
                          <app-icon icon="x" (click)="removeProvider(providerId, i)"></app-icon>
                        }
                      </li>
                    }
                  </ul>
                </div>
              }
            </div>
          </div>

        </div>
      </ng-template>

      <div class="button-bar clearfix">
        <button class="btn btn-invert btn-primary" (click)="addAttributeToList()">+ Add attribute</button>
        <button class="btn btn-primary pull-right" (click)="save()">Save</button>
        <button class="btn btn-invert btn-default pull-right" (click)="cancel()">Cancel</button>
      </div>
    </div>
  </div>
</div>